module.exports = __webpack_public_path__ + "static/media/banner-old.1d473a43.svg";